import { atom } from 'jotai';

export const mutationLoadingAtom = atom<boolean>(false);
